import { organization } from './organization';

export const en = {
  organization,
};
